module.exports = __webpack_public_path__ + "img/alp02.5d96b372.png";